module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-wrapper"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("멘토 답글")]), _vm._v(" "), _c('div', {
    staticClass: "comment-input-wrapper"
  }, [_c('div', {
    staticClass: "comment-input-user-profile background-image",
    style: ({
      'background-image': 'url(' + _vm.getPhotoUrl(_vm.photoUrl) + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-input-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.content),
      expression: "content",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "comment-input-box__textarea",
    attrs: {
      "placeholder": "답글을 작성해주세요.",
      "title": "답글을 작성해주세요."
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-input-box__submit-box"
  }, [_c('p', {
    staticClass: "comment-input-box__count"
  }, [_vm._v(_vm._s(_vm.content_length) + "/2000")]), _vm._v(" "), _c('button', {
    staticClass: "comment-input-box__submit-btn",
    on: {
      "click": _vm.addComment
    }
  }, [_vm._v("등록")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a97935d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/comment/PostMentoring.vue
// module id = 1494
// module chunks = 6